import { render, staticRenderFns } from "./RsvpConfig.vue?vue&type=template&id=6ae46c06&"
import script from "./RsvpConfig.vue?vue&type=script&lang=js&"
export * from "./RsvpConfig.vue?vue&type=script&lang=js&"
import style0 from "./RsvpConfig.vue?vue&type=style&index=0&id=6ae46c06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports